/**
 * What "cast" means on an iPhone: the TV page itself runs on a portrait
 * phone, and the mirrored screen is exactly what the TV shows — a skinny
 * letterboxed column unless the page draws landscape. The fix is the one
 * video players use: draw the page at the swapped size and rotate the whole
 * thing 90°, so the mirror sees a full-width table.
 */
export interface MirrorLayout {
  /** True when the page must draw landscape and turn. */
  rotate: boolean;
  /** The size to draw at — already swapped when `rotate` is true. */
  width: number;
  height: number;
}

export function mirrorLayout(viewportWidth: number, viewportHeight: number): MirrorLayout {
  const portrait = viewportHeight > viewportWidth;
  return portrait
    ? { rotate: true, width: viewportHeight, height: viewportWidth }
    : { rotate: false, width: viewportWidth, height: viewportHeight };
}
